module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500italic.woff?18d00f739ff1e1c52db1a1c0d9e98129";